import React, { useRef, useState, useEffect } from 'react';
import { Button } from 'antd';
import { CameraTwoTone, PauseCircleFilled, PlayCircleFilled } from '@ant-design/icons';

interface VideoViewerProps {
  videoUrl: string;
  onCapture: (file: File, image?: any) => void; 
}

const VideoViewer: React.FC<VideoViewerProps> = ({ videoUrl, onCapture }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [videoReady, setVideoReady] = useState(false);
  const [canvasReady, setCanvasReady] = useState(false);

  const handleSave = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (video && canvas && videoReady && canvasReady) {
      const context = canvas.getContext('2d');
      if (context) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "captura-video.png");
            const image = canvas.toDataURL('image/png');
            onCapture(file,image);
          }
        }, 'image/png');
      }
    }
  };

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.src = videoUrl;
      video.onloadedmetadata = () => {
        const canvas = canvasRef.current;

        if (canvas) {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          setCanvasReady(true);
        }

        setVideoReady(true);
      };
    }
  }, [videoUrl]);

  window.onkeydown = (e) => {
      if (e.key === 'F7') {
        e.preventDefault();
        videoRef.current?.play();
      } else if (e.key === 'F8') {
        e.preventDefault();
        videoRef.current?.pause();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        seekVideo(0.5); 
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        seekVideo(-0.5); 
      }
    };

  const seekVideo = (time: number) => {
    const video = videoRef.current;
    if (video) {
      video.currentTime += time;
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <video crossOrigin='anonymous' width={'100%'} height="90%" ref={videoRef} controls style = {{ maxHeight: "475px" }}></video>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
        <Button icon={<PlayCircleFilled />} onClick={() => videoRef.current?.play()}>
          Reproducir
        </Button>
        <Button icon={<PauseCircleFilled />} onClick={() => videoRef.current?.pause()} style={{ marginLeft: '10px' }}>
          Pausar
        </Button>
        <Button icon={<CameraTwoTone />} onClick={handleSave} style={{ marginLeft: '10px' }}>
          Capturar imagen Infracción
        </Button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between',marginTop: '1rem', color:'grey'}}>
      <p>Adelantar  medio segundo: flecha ➡️ del teclado</p>
      <p>Retroceder medio segundo: flecha ⬅️ del teclado</p>
      </div>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </div>
  );
};

export default VideoViewer;
